import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

const BUSINESS_NAME = 'My Local App Business';

const PrivacyPage: React.FC = () => {
	return (
		<Box sx={{ py: 6 }}>
			<Container maxWidth="md">
				<Paper variant="outlined" sx={{ p: 4 }}>
					<Typography variant="h4" fontWeight={700} gutterBottom>
						Privacy Policy
					</Typography>
					<Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
						{BUSINESS_NAME}
					</Typography>

					<Typography variant="body1" paragraph>
						We care about your privacy. This page explains what we collect, why, and how we handle it—in plain language.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						What we collect
					</Typography>
					<Typography variant="body1" paragraph>
						We collect what we need to run the app: account info (e.g. email) when you sign up, data you add (recipes, batches, inventory), and basic usage information. If you pay us, our payment provider (Stripe) processes payment details—we don’t store your full card number.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						How we use it
					</Typography>
					<Typography variant="body1" paragraph>
						We use your data to provide the service, improve the app, handle support, and comply with the law. We don’t sell your personal information to third parties for their marketing.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						Who else sees it
					</Typography>
					<Typography variant="body1" paragraph>
						We use services like Amazon (for hosting and auth) and Stripe (for payments). They process data on our behalf under their own privacy policies. We’re not responsible for how those third parties handle your data—that’s governed by their terms and applicable law.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						Security
					</Typography>
					<Typography variant="body1" paragraph>
						We take reasonable steps to protect your data, but no system is 100% secure. We can’t guarantee that your data will never be accessed, disclosed, or lost; you use our service with that understanding.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						Your choices
					</Typography>
					<Typography variant="body1" paragraph>
						You can access and update your account info in the app. You can ask us to delete your data or account; we’ll do so subject to what we need to keep for legal or operational reasons. Contact us via the contact form for requests.
					</Typography>

					<Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
						Changes and questions
					</Typography>
					<Typography variant="body1" paragraph>
						We may update this policy from time to time. If we make meaningful changes, we’ll post the new version here. Continued use of the app after changes means you accept the updated policy. If you have questions, use our contact form.
					</Typography>
				</Paper>
			</Container>
		</Box>
	);
};

export default PrivacyPage;
